export default __webpack_public_path__ + "static/media/further_exploring.7603092a.png";